import LoadingSpinner from 'tio-employee/components/tas/loading-spinner';

<template>
  <div class="flex h-screen w-screen items-center justify-center">
    <LoadingSpinner />
  </div>
</template>
